/* unplugin-vue-components disabled */import { render } from "./Migrator.vue?vue&type=template&id=6ffae15a&scoped=true"
import script from "./Migrator.vue?vue&type=script&lang=js"
export * from "./Migrator.vue?vue&type=script&lang=js"

import "./Migrator.vue?vue&type=style&index=0&id=6ffae15a&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ffae15a"]])

export default __exports__